// ============================================
// Wizard Module Entry Point
// 마법사 모듈 진입점
// ============================================

// 상태 관리
export {
  getWizardState,
  resetWizardState,
  getCurrentStep,
  getSelectedTags
} from './state.js';

// 모달 관리
export {
  openCreationMethodModal,
  closeCreationMethodModal,
  openWizardModal,
  closeWizardModal,
  selectCreationMethod,
  goToNextStep,
  goToPreviousStep
} from './modal.js';

// 이벤트
export {
  bindWizardEvents,
  unbindWizardEvents,
  loadImageModels,
  onStepEnter
} from './events.js';

// 생성
export {
  generateFromWizard,
  calculateWizardCost
} from './generate.js';

// ============================================
// WizardModule 객체 (window 노출용)
// ============================================

import {
  openCreationMethodModal,
  closeCreationMethodModal,
  openWizardModal,
  closeWizardModal,
  selectCreationMethod
} from './modal.js';

import { bindWizardEvents, unbindWizardEvents } from './events.js';
import { generateFromWizard } from './generate.js';

export const WizardModule = {
  // 모달
  openMethodModal: openCreationMethodModal,
  closeMethodModal: closeCreationMethodModal,
  openWizard: openWizardModal,
  closeWizard: closeWizardModal,
  selectMethod: selectCreationMethod,

  // 이벤트
  bindEvents: bindWizardEvents,
  unbindEvents: unbindWizardEvents,

  // 생성
  generate: generateFromWizard
};

// HTML에서 동적 호출용
window.WizardModule = WizardModule;
